import type {
  Locale,
} from "~/stores/locale";

export interface PaymentCheckoutEvidence {
  language: Locale;
  termsAccepted: true;
  termsMethodLabel: string;
  privacyMethodLabel: string;
  confirmButtonLabel: string;
}

export const usePaymentCheckout = () => {
  const {
    $t,
  } = useNuxtApp();
  const localeStore = useLocaleStore();

  const buildEvidence = (
    confirmButtonLabel: string,
    purchaseKind: "credit_package" | "plan",
  ): PaymentCheckoutEvidence => ({
    language: localeStore.currentLocale,
    termsAccepted: true,
    termsMethodLabel: $t(purchaseKind === "credit_package"
      ? "PAYMENT_CHECKOUT.TERMS_ACCEPTANCE_CREDIT_RECORD"
      : "PAYMENT_CHECKOUT.TERMS_ACCEPTANCE_PLAN_RECORD"),
    privacyMethodLabel: $t("PAYMENT_CHECKOUT.PRIVACY_INFO_RECORD"),
    confirmButtonLabel,
  });

  return {
    buildEvidence,
  };
};
